import request from "../../utils/request";
import { Result } from "@/models/general";
import { SurveyResponseInput, SurveyResponseView, SurveyStatsView } from '../../models/preformanceManagement';

export async function submitSurveyResponse(input: SurveyResponseInput): Promise<Result<SurveyResponseView>> {
    const response = await request.post<Result<SurveyResponseView>>('Survey/SubmitResponse', input);
    return response.data;
}

export async function hasSubmittedSurvey(): Promise<Result<{ hasSubmitted: boolean }>> {
    const response = await request.get('Survey/HasSubmitted');
    return response.data;
}

export async function getSurveyStats(month?: Date): Promise<Result<SurveyStatsView>> {
    const params = month ? { month: month.toISOString() } : {};
    const response = await request.get<Result<SurveyStatsView>>('Survey/GetStats', { params });
    return response.data;
}
